import { useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Spinner from './Spinner';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useUser();

  useEffect(() => {
    if (!isLoading && isAuthenticated && user && !user.license_valid) {
      window.location.href = '#cgi-bin/main.cgi';
    }
  }, [isLoading, isAuthenticated, user]);

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'var(--color-background-secondary)',
          minHeight: '100vh',
        }}
      >
        <Spinner size={50} color="var(--color-primary-600)" />
      </div>
    );
  }

  if (!isLoading && !isAuthenticated) {
    return (
      <div
        style={{
          padding: '50px',
          textAlign: 'center',
          fontSize: '24px',
          color: 'var(--color-text-primary)',
          backgroundColor: 'var(--color-background-secondary)',
          minHeight: '100vh',
        }}
      >
        Authentication error. Please refresh the page.
      </div>
    );
  }

  return children;
}
